<div class="grid grid-cols-2">
    @if (shouldShowSkipButton()) {
    <div class="col-span-1">
        <div class="mt-10 flex justify-start">
            <button type="button" (click)="onSkip()" class="cursor-pointer inline-flex items-center gap-2 px-10 py-2 bg-gradient-to-r from-gray-600 to-gray-500
                           text-white text-base font-semibold rounded-xl shadow-lg hover:from-blue-700 hover:to-blue-600
                           transition-all transform hover:scale-105">
                Skip
            </button>
        </div>
    </div>
    } @else {
    <div class="col-span-1"></div>
    }

    <div class="col-span-1">
        <div class="mt-10 flex justify-end">
            <button type="submit" form="userForm" class="cursor-pointer inline-flex items-center gap-2 px-10 py-4 bg-gradient-to-r from-blue-600 to-blue-500
                text-white text-base font-semibold rounded-xl shadow-lg hover:from-blue-700 hover:to-blue-600
                transition-all transform hover:scale-105">
                🚀 Submit
            </button>
        </div>
    </div>
</div>